/* Si modifications sur ce nuancier, 
il est recommandé d'effectuer des modifications sur colors.js*/
// NUANCIER
export const Colors = {
   black: '#000',
   white: '#fff',
   corail: '#F39A88',
   corail2: '#fbf0e2',
   corail3: '#fdf4eb',
   gris1: '#49494A',
   gris2: '#878787',
   gris3: '#F2F2F2',
   gris4: '#b2b2b2',
   sable: '#FBF0E2',
   rouge: '#e20613',
   vert: '#289548',
   bleu: '#6B91AB',
   bleuFonce: '#0000CC',
}
